export enum BlockGroupEnum {
  MenuAndStartPage = 'blockgroup.menuAndStartPage',
  Text = 'blockgroup.text',
  ImageAndVideo = 'blockgroup.imageAndVideo',
  Spacing = 'blockgroup.spacing',
  Lists = 'blockgroup.lists',
  Interactive = 'blockgroup.interactive',
  FooterAndContactInformation = 'blockgroup.footerAndContactInformation',
}
